import React from 'react';
import { Popover } from 'antd';
import CalendarEventViewItem, { Event } from '../CalendarEventViewItem';
import Text from '../Text';
import './CalendarEventItem.less';

export type CalendarEventItemProps = Event & {
  onItemClick?: (item: any) => void;
  onBook?: (item: any) => void;
  onCancel?: (item: any) => void;
  onReschedule?: (item: any) => void;
};

const CalendarEventItem: React.FC<CalendarEventItemProps> = ({
  title,
  ...rest
}) => {
  return (
    <Popover
      overlayClassName="t-calendar-event-popup"
      trigger="click"
      getPopupContainer={(trigger) =>
        (trigger.parentNode.parentElement.getAttribute('type') !== 'popup'
          ? document.body
          : trigger.parentNode) as HTMLElement
      }
      content={
        <CalendarEventViewItem
          {...rest}
          titleColor="black"
          avatarTextColor="black"
          title={title}
        />
      }
    >
      <div className="t-calendar-event-item">
        <Text level={3} rows={1}>
          {title}
        </Text>
      </div>
    </Popover>
  );
};

export default CalendarEventItem;
